import { render, staticRenderFns } from "./ConstructionTaskForm.vue?vue&type=template&id=2c03d8db&"
import script from "./ConstructionTaskForm.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTaskForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports